var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mx-0 px-0",attrs:{"fluid":"","no-gutters":""}},[_c('match-banner',{attrs:{"match":_vm.match}}),_c('facebook-post-match-details',{class:_vm.$vuetify.breakpoint.mobile ? '' : 'px-16',attrs:{"match":_vm.match}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }